export default {
  namespaced: true,
  state: {
    id: ''
  },
  mutations: {
    SET_ID: (state, data) => {
      state.id = data
    }
  },
  actions: {
    setId ({ commit }, id) {
      commit('SET_ID', id)
    }
  }
}